import * as types from '../actions/types';

const initState = {
    data: null,
    loading: false,
    loadingError: null
};

export default function DashboardReducer (state = initState, action) {
    switch (action.type) {

        case types.DASHBOARD_LOAD:
            return {...state, loading: true, loadingError: null, data: null };

        case types.DASHBOARD_LOAD_SUCCESS:
            return {...state, loading: false, loadingError: null, data: action.payload };

        case types.DASHBOARD_LOAD_ERROR:
            return {...state, loading: false, data: null, loadingError: action.payload};

        default:
            return state;
    }
}
